import React, { useState } from "react";
import Navbar3 from "../Components/Navbar3";

function EventBooking() {
  const [currentStep, setCurrentStep] = useState(1);
  const [showTournamentSport, setShowTournamentSport] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const [booking, setBooking] = useState({
    eventType: "",
    tournamentSport: "",

    eventName: "",
    expectedGuests: "",
    duration: "",
    ageGroup: "",

    contactName: "",
    email: "",
    phone: "",
    preferredDate: "",
    backupDate: "",
    preferredTime: "",

    services: [],
    budget: "",
    specialRequirements: ""
  });

  const eventTypes = [
    {
      value: "Birthday Party",
      title: "Birthday Party",
      description: "Celebrate birthdays and special milestones.",
      icon: "bi-cake2"
    },
    {
      value: "Corporate Event",
      title: "Corporate Event",
      description: "Meetings, team events and company gatherings.",
      icon: "bi-briefcase"
    },
    {
      value: "Tournament",
      title: "Sporting Event/Tournament",
      description: "Competitive sporting events and tournaments.",
      icon: "bi-trophy"
    },
    {
      value: "Private Venue",
      title: "Private Venue",
      description: "Reserve space for your private event.",
      icon: "bi-building"
    },
    {
      value: "Catering & Entertainment",
      title: "Catering & Entertainment",
      description: "Food, entertainment and event services.",
      icon: "bi-music-note-beamed"
    }
  ];

  const tournamentSports = [
    {
      value: "Basketball",
      title: "Basketball",
      description: "Basketball tournament",
      icon: "/s3/icons/basketball.svg"
    },
    {
      value: "Volleyball",
      title: "Volleyball",
      description: "Volleyball tournament",
      icon: "/s3/icons/volleyball.svg"
    },
    {
      value: "Flag Football",
      title: "Flag Football",
      description: "Flag football tournament",
      icon: "/s3/icons/flag-football.svg"
    },
    {
      value: "Pickleball",
      title: "Pickleball",
      description: "Pickleball tournament",
      icon: "/s3/icons/pickleball.svg"
    }
  ];

  const steps = [
    "Event Type",
    "Event Details",
    "Contact & Schedule",
    "Services & Review"
  ];

  const ageGroups = [
    "Child (0-12)",
    "Teen (13-17)",
    "Adult (18-64)",
    "Senior (65+)"
  ];

  const services = [
    "Catering",
    "Entertainment",
    "Decoration",
    "Equipment",
    "Staffing"
  ];

  const timeSlots = [
    "Morning (8AM-12PM)",
    "Afternoon (12PM-5PM)",
    "Evening (5PM-11PM)"
  ];

  function updateBooking(field, value) {
    setBooking((previousBooking) => ({
      ...previousBooking,
      [field]: value
    }));

    setErrors((previousErrors) => ({
      ...previousErrors,
      [field]: ""
    }));

    setSubmitError("");
  }

  function selectEventType(eventType) {
    setBooking((previousBooking) => ({
      ...previousBooking,
      eventType,
      tournamentSport:
        eventType === "Tournament"
          ? previousBooking.tournamentSport
          : ""
    }));

    setErrors((previousErrors) => ({
      ...previousErrors,
      eventType: "",
      tournamentSport: ""
    }));

    setSubmitError("");
  }

  function toggleService(service) {
    setBooking((previousBooking) => {
      const isSelected =
        previousBooking.services.includes(service);

      return {
        ...previousBooking,
        services: isSelected
          ? previousBooking.services.filter(
              (selectedService) =>
                selectedService !== service
            )
          : [
              ...previousBooking.services,
              service
            ]
      };
    });

    setSubmitError("");
  }

  function validateEventType() {
    const newErrors = {};

    if (!booking.eventType) {
      newErrors.eventType =
        "Please select an event type.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  }

  function validateTournamentSport() {
    const newErrors = {};

    if (!booking.tournamentSport) {
      newErrors.tournamentSport =
        "Please select a sport.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  }

  function validateStepTwo() {
    const newErrors = {};

    if (!booking.eventName.trim()) {
      newErrors.eventName =
        "Event name is required.";
    }

    if (!booking.expectedGuests) {
      newErrors.expectedGuests =
        "Expected guests is required.";
    }

    if (!booking.duration) {
      newErrors.duration =
        "Duration is required.";
    }

    if (
      booking.eventType === "Birthday Party" &&
      !booking.ageGroup
    ) {
      newErrors.ageGroup =
        "Please select an age group.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  }

  function validateStepThree() {
    const newErrors = {};

    if (!booking.contactName.trim()) {
      newErrors.contactName =
        "Contact name is required.";
    }

    if (!booking.email.trim()) {
      newErrors.email =
        "Email address is required.";
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
        booking.email
      )
    ) {
      newErrors.email =
        "Please enter a valid email address.";
    }

    if (!booking.phone.trim()) {
      newErrors.phone =
        "Phone number is required.";
    }

    if (!booking.preferredDate) {
      newErrors.preferredDate =
        "Preferred date is required.";
    }

    if (!booking.preferredTime) {
      newErrors.preferredTime =
        booking.eventType === "Birthday Party"
          ? "Preferred time is required."
          : "Please select a preferred time slot.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  }

  function validateStepFour() {
    const newErrors = {};

    if (!booking.budget) {
      newErrors.budget =
        "Please select an estimated budget.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  }

  function handleEventTypeNext() {
    if (!validateEventType()) {
      return;
    }

    if (booking.eventType === "Tournament") {
      setShowTournamentSport(true);
      return;
    }

    setErrors({});
    setCurrentStep(2);
  }

  function handleTournamentSportNext() {
    if (!validateTournamentSport()) {
      return;
    }

    setErrors({});
    setShowTournamentSport(false);
    setCurrentStep(2);
  }

  function handleTournamentSportBack() {
    setErrors({});
    setShowTournamentSport(false);
  }

  function handleStepTwoNext() {
    if (!validateStepTwo()) {
      return;
    }

    setErrors({});
    setCurrentStep(3);
  }

  function handleStepThreeNext() {
    if (!validateStepThree()) {
      return;
    }

    setErrors({});
    setCurrentStep(4);
  }

  function previousStep() {
    setErrors({});
    setSubmitError("");

    setCurrentStep((previousStepValue) =>
      Math.max(previousStepValue - 1, 1)
    );
  }

  async function handleSubmit() {
    if (!validateStepFour()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitError("");

    const bookingRequest = {
      eventType: booking.eventType,
      tournamentSport: booking.tournamentSport,
      eventName: booking.eventName,
      expectedGuests: booking.expectedGuests,
      duration: booking.duration,
      ageGroup: booking.ageGroup,
      preferredDate: booking.preferredDate,
      backupDate: booking.backupDate,
      preferredTime: booking.preferredTime,
      budget: booking.budget,
      contactName: booking.contactName,
      email: booking.email,
      phone: booking.phone,
      services: booking.services,
      specialRequirements: booking.specialRequirements
    };

    try {
      const response = await fetch(
        "https://api.adssportscomplex.com/v1/bookings",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(bookingRequest)
        }
      );

      if (!response.ok) {
        let errorMessage =
          "We were unable to submit your event request. Please try again.";

        try {
          const errorData = await response.json();

          if (errorData.message) {
            errorMessage = errorData.message;
          }
        } catch {
          // Use the default error message.
        }

        throw new Error(errorMessage);
      }

      let responseData = {};

      try {
        responseData = await response.json();
      } catch {
        // A successful response does not have to contain JSON.
      }

      console.log(
        "Event booking created:",
        responseData
      );

      setSubmitted(true);

    } catch (error) {
      console.error(
        "Event booking submission failed:",
        error
      );

      setSubmitError(
        error.message ||
          "We were unable to submit your event request. Please try again."
      );

    } finally {
      setIsSubmitting(false);
    }
  }

  if (submitted) {
    return (
      <>
        <Navbar3 />

        <main className="event-booking-page">
          <section className="event-wizard py-5">
            <div className="container">
              <div className="event-submitted text-center">

                <div className="event-submitted-icon mb-4">
                  <i className="bi bi-check-lg"></i>
                </div>

                <h1 className="futuraPTBold mb-3">
                  Event Request Submitted!
                </h1>

                <p className="text-secondary mb-0">
                  Thank you for your event request.
                  Our event planning team will contact
                  you soon to discuss your event and
                  next steps.
                </p>

              </div>
            </div>
          </section>
        </main>
      </>
    );
  }

  return (
    <>
      <Navbar3 />

      <main className="event-booking-page">
        <section className="event-wizard py-5">
          <div className="container">
            <div className="event-wizard-card">

              <div className="mb-5">

                <h1 className="futuraPTBold mb-2">
                  {showTournamentSport
                    ? "Plan Your Tournament"
                    : "Plan Your Event"}
                </h1>

                <p className="text-secondary mb-4">
                  {showTournamentSport
                    ? "Choose your sport."
                    : "Tell us about your event and our team will help you bring it together."}
                </p>

                <div className="event-progress">

                  <div className="progress mb-3">
                    <div
                      className="progress-bar bg-success"
                      role="progressbar"
                      style={{
                        width:
                          `${(currentStep / steps.length) * 100}%`
                      }}
                      aria-valuenow={currentStep}
                      aria-valuemin="1"
                      aria-valuemax={steps.length}
                    />
                  </div>

                  <div className="row g-2">

                    {steps.map((step, index) => {
                      const stepNumber = index + 1;

                      return (
                        <div
                          className="col-6 col-lg-3"
                          key={step}
                        >
                          <div
                            className={
                              stepNumber === currentStep
                                ? "event-progress-label active"
                                : "event-progress-label"
                            }
                          >
                            <span className="event-progress-number">
                              {stepNumber}
                            </span>

                            {step}
                          </div>
                        </div>
                      );
                    })}

                  </div>

                </div>

              </div>

              {currentStep === 1 &&
                !showTournamentSport && (
                <div className="event-step">

                  <div className="text-center mb-5">

                    <h2 className="futuraPTBold">
                      What's the Occasion?
                    </h2>

                    <p className="text-secondary">
                      Select the type of event you're planning.
                    </p>

                  </div>

                  <div className="row g-4">

                    {eventTypes.map((eventType) => (
                      <div
                        className="col-12 col-md-6 col-xl-4 d-flex"
                        key={eventType.value}
                      >
                        <button
                          type="button"
                          className={
                            booking.eventType ===
                            eventType.value
                              ? "event-type-card selected"
                              : "event-type-card"
                          }
                          onClick={() =>
                            selectEventType(
                              eventType.value
                            )
                          }
                        >
                          <i
                            className={`bi ${eventType.icon} event-type-card__icon`}
                            aria-hidden="true"
                          ></i>

                          <h3 className="futuraPTBold">
                            {eventType.title}
                          </h3>

                          <p>
                            {eventType.description}
                          </p>
                        </button>
                      </div>
                    ))}

                  </div>

                  {errors.eventType && (
                    <div className="text-danger mt-3">
                      {errors.eventType}
                    </div>
                  )}

                  <div className="d-flex justify-content-end mt-5">

                    <button
                      type="button"
                      className="btn btn-success px-5"
                      onClick={handleEventTypeNext}
                    >
                      Next
                    </button>

                  </div>

                </div>
              )}

              {currentStep === 1 &&
                showTournamentSport && (
                <div className="event-step">

                  <div className="text-center mb-5">

                    <h2 className="futuraPTBold">
                      Select Your Sport
                    </h2>

                    <p className="text-secondary">
                      Choose the sport for your tournament.
                    </p>

                  </div>

                  <div className="row g-4">

                    {tournamentSports.map((sport) => (
                      <div
                        className="col-12 col-md-6 d-flex"
                        key={sport.value}
                      >
                        <button
                          type="button"
                          className={
                            booking.tournamentSport ===
                            sport.value
                              ? "event-type-card selected"
                              : "event-type-card"
                          }
                          onClick={() =>
                            updateBooking(
                              "tournamentSport",
                              sport.value
                            )
                          }
                        >
                          <img
                            src={sport.icon}
                            alt=""
                            className="tournament-sport-icon"
                          />

                          <h3 className="futuraPTBold">
                            {sport.title}
                          </h3>

                          <p>
                            {sport.description}
                          </p>
                        </button>
                      </div>
                    ))}

                  </div>

                  {errors.tournamentSport && (
                    <div className="text-danger mt-3">
                      {errors.tournamentSport}
                    </div>
                  )}

                  <div className="d-flex justify-content-between mt-5">

                    <button
                      type="button"
                      className="btn btn-secondary px-4"
                      onClick={
                        handleTournamentSportBack
                      }
                    >
                      Back
                    </button>

                    <button
                      type="button"
                      className="btn btn-success px-5"
                      onClick={
                        handleTournamentSportNext
                      }
                    >
                      Next
                    </button>

                  </div>

                </div>
              )}

              {currentStep === 2 && (
                <div className="event-step">

                  <div className="text-center mb-5">

                    <h2 className="futuraPTBold">
                      Event Details
                    </h2>

                    <p className="text-secondary">
                      Tell us about your{" "}
                      {booking.eventType.toLowerCase()}.
                    </p>

                  </div>

                  <div className="row g-4">

                    <div className="col-12">

                      <label
                        htmlFor="eventName"
                        className="form-label"
                      >
                        * Event Name
                      </label>

                      <input
                        id="eventName"
                        type="text"
                        className={`form-control ${
                          errors.eventName
                            ? "is-invalid"
                            : ""
                        }`}
                        value={booking.eventName}
                        onChange={(event) =>
                          updateBooking(
                            "eventName",
                            event.target.value
                          )
                        }
                      />

                      {errors.eventName && (
                        <div className="invalid-feedback">
                          {errors.eventName}
                        </div>
                      )}

                    </div>

                    <div className="col-12 col-md-6">

                      <label
                        htmlFor="expectedGuests"
                        className="form-label"
                      >
                        * Expected Number of Guests
                      </label>

                      <input
                        id="expectedGuests"
                        type="number"
                        min="1"
                        className={`form-control ${
                          errors.expectedGuests
                            ? "is-invalid"
                            : ""
                        }`}
                        value={booking.expectedGuests}
                        onChange={(event) =>
                          updateBooking(
                            "expectedGuests",
                            event.target.value
                          )
                        }
                      />

                      {errors.expectedGuests && (
                        <div className="invalid-feedback">
                          {errors.expectedGuests}
                        </div>
                      )}

                    </div>

                    <div className="col-12 col-md-6">

                      <label
                        htmlFor="duration"
                        className="form-label"
                      >
                        * Duration (Hours)
                      </label>

                      <input
                        id="duration"
                        type="number"
                        min="1"
                        className={`form-control ${
                          errors.duration
                            ? "is-invalid"
                            : ""
                        }`}
                        value={booking.duration}
                        onChange={(event) =>
                          updateBooking(
                            "duration",
                            event.target.value
                          )
                        }
                      />

                      {errors.duration && (
                        <div className="invalid-feedback">
                          {errors.duration}
                        </div>
                      )}

                    </div>

                    {booking.eventType ===
                      "Birthday Party" && (
                      <div className="col-12">

                        <label className="form-label">
                          * Age Group
                        </label>

                        <div className="row g-3">

                          {ageGroups.map((ageGroup) => (
                            <div
                              className="col-12 col-sm-6 col-xl-3"
                              key={ageGroup}
                            >
                              <button
                                type="button"
                                className={
                                  booking.ageGroup ===
                                  ageGroup
                                    ? "btn btn-success w-100"
                                    : "btn btn-outline-secondary w-100"
                                }
                                onClick={() =>
                                  updateBooking(
                                    "ageGroup",
                                    ageGroup
                                  )
                                }
                              >
                                {ageGroup}
                              </button>
                            </div>
                          ))}

                        </div>

                        {errors.ageGroup && (
                          <div className="text-danger mt-2">
                            {errors.ageGroup}
                          </div>
                        )}

                      </div>
                    )}

                  </div>

                  <div className="d-flex justify-content-between mt-5">

                    <button
                      type="button"
                      className="btn btn-secondary px-4"
                      onClick={() => {
                        setErrors({});

                        if (
                          booking.eventType ===
                          "Tournament"
                        ) {
                          setCurrentStep(1);
                          setShowTournamentSport(true);
                        } else {
                          previousStep();
                        }
                      }}
                    >
                      Back
                    </button>

                    <button
                      type="button"
                      className="btn btn-success px-5"
                      onClick={handleStepTwoNext}
                    >
                      Next
                    </button>

                  </div>

                </div>
              )}

              {currentStep === 3 && (
                <div className="event-step">

                  <div className="text-center mb-5">

                    <h2 className="futuraPTBold">
                      Contact &amp; Scheduling
                    </h2>

                    <p className="text-secondary">
                      Tell us how to reach you and when
                      you'd like to hold your event.
                    </p>

                  </div>

                  <div className="row g-4">

                    <div className="col-12">

                      <label
                        htmlFor="contactName"
                        className="form-label"
                      >
                        * Contact Name
                      </label>

                      <input
                        id="contactName"
                        type="text"
                        className={`form-control ${
                          errors.contactName
                            ? "is-invalid"
                            : ""
                        }`}
                        value={booking.contactName}
                        onChange={(event) =>
                          updateBooking(
                            "contactName",
                            event.target.value
                          )
                        }
                      />

                      {errors.contactName && (
                        <div className="invalid-feedback">
                          {errors.contactName}
                        </div>
                      )}

                    </div>

                    <div className="col-12 col-md-6">

                      <label
                        htmlFor="email"
                        className="form-label"
                      >
                        * Email Address
                      </label>

                      <input
                        id="email"
                        type="email"
                        className={`form-control ${
                          errors.email
                            ? "is-invalid"
                            : ""
                        }`}
                        value={booking.email}
                        onChange={(event) =>
                          updateBooking(
                            "email",
                            event.target.value
                          )
                        }
                      />

                      {errors.email && (
                        <div className="invalid-feedback">
                          {errors.email}
                        </div>
                      )}

                    </div>

                    <div className="col-12 col-md-6">

                      <label
                        htmlFor="phone"
                        className="form-label"
                      >
                        * Phone Number
                      </label>

                      <input
                        id="phone"
                        type="tel"
                        className={`form-control ${
                          errors.phone
                            ? "is-invalid"
                            : ""
                        }`}
                        value={booking.phone}
                        onChange={(event) =>
                          updateBooking(
                            "phone",
                            event.target.value
                          )
                        }
                      />

                      {errors.phone && (
                        <div className="invalid-feedback">
                          {errors.phone}
                        </div>
                      )}

                    </div>

                    <div className="col-12 col-md-6">

                      <label
                        htmlFor="preferredDate"
                        className="form-label"
                      >
                        * Preferred Date
                      </label>

                      <input
                        id="preferredDate"
                        type="date"
                        className={`form-control ${
                          errors.preferredDate
                            ? "is-invalid"
                            : ""
                        }`}
                        value={booking.preferredDate}
                        onChange={(event) =>
                          updateBooking(
                            "preferredDate",
                            event.target.value
                          )
                        }
                      />

                      {errors.preferredDate && (
                        <div className="invalid-feedback">
                          {errors.preferredDate}
                        </div>
                      )}

                    </div>

                    <div className="col-12 col-md-6">

                      <label
                        htmlFor="backupDate"
                        className="form-label"
                      >
                        Backup Date (Optional)
                      </label>

                      <input
                        id="backupDate"
                        type="date"
                        className="form-control"
                        value={booking.backupDate}
                        onChange={(event) =>
                          updateBooking(
                            "backupDate",
                            event.target.value
                          )
                        }
                      />

                    </div>

                    {booking.eventType !==
                    "Birthday Party" ? (

                      <div className="col-12">

                        <label className="form-label">
                          * Preferred Time Slot
                        </label>

                        <div className="row g-3">

                          {timeSlots.map((timeSlot) => (
                            <div
                              className="col-12 col-md-4"
                              key={timeSlot}
                            >
                              <button
                                type="button"
                                className={
                                  booking.preferredTime ===
                                  timeSlot
                                    ? "btn btn-success w-100"
                                    : "btn btn-outline-secondary w-100"
                                }
                                onClick={() =>
                                  updateBooking(
                                    "preferredTime",
                                    timeSlot
                                  )
                                }
                              >
                                {timeSlot}
                              </button>
                            </div>
                          ))}

                        </div>

                        {errors.preferredTime && (
                          <div className="text-danger mt-2">
                            {errors.preferredTime}
                          </div>
                        )}

                      </div>

                    ) : (

                      <div className="col-12">

                        <label
                          htmlFor="preferredTime"
                          className="form-label"
                        >
                          * Preferred Time
                        </label>

                        <input
                          id="preferredTime"
                          type="time"
                          className={`form-control ${
                            errors.preferredTime
                              ? "is-invalid"
                              : ""
                          }`}
                          value={booking.preferredTime}
                          onChange={(event) =>
                            updateBooking(
                              "preferredTime",
                              event.target.value
                            )
                          }
                        />

                        {errors.preferredTime && (
                          <div className="invalid-feedback">
                            {errors.preferredTime}
                          </div>
                        )}

                      </div>

                    )}

                  </div>

                  <div className="d-flex justify-content-between mt-5">

                    <button
                      type="button"
                      className="btn btn-secondary px-4"
                      onClick={previousStep}
                    >
                      Back
                    </button>

                    <button
                      type="button"
                      className="btn btn-success px-5"
                      onClick={handleStepThreeNext}
                    >
                      Next
                    </button>

                  </div>

                </div>
              )}

              {currentStep === 4 && (
                <div className="event-step">

                  <div className="text-center mb-5">

                    <h2 className="futuraPTBold">
                      Services &amp; Final Details
                    </h2>

                    <p className="text-secondary">
                      Customize your event experience.
                    </p>

                  </div>

                  <div className="mb-5">

                    <label className="form-label">
                      Services Needed
                    </label>

                    <div className="row g-3">

                      {services.map((service) => (
                        <div
                          className="col-12 col-md-6 col-xl-4"
                          key={service}
                        >
                          <button
                            type="button"
                            className={
                              booking.services.includes(
                                service
                              )
                                ? "btn btn-success w-100 event-service-button"
                                : "btn btn-outline-secondary w-100 event-service-button"
                            }
                            onClick={() =>
                              toggleService(service)
                            }
                          >
                            {service}
                          </button>
                        </div>
                      ))}

                    </div>

                  </div>

                  <div className="row g-4 mb-5">

                    <div className="col-12">

                      <label
                        htmlFor="budget"
                        className="form-label"
                      >
                        * Estimated Budget
                      </label>

                      <select
                        id="budget"
                        className={`form-select ${
                          errors.budget
                            ? "is-invalid"
                            : ""
                        }`}
                        value={booking.budget}
                        onChange={(event) =>
                          updateBooking(
                            "budget",
                            event.target.value
                          )
                        }
                      >
                        <option value="">
                          Select Budget
                        </option>

                        <option value="Under $500">
                          Under $500
                        </option>

                        <option value="$500 - $1,000">
                          $500 - $1,000
                        </option>

                        <option value="$1,000 - $2,500">
                          $1,000 - $2,500
                        </option>

                        <option value="$2,500 - $5,000">
                          $2,500 - $5,000
                        </option>

                        <option value="$5,000+">
                          $5,000+
                        </option>
                      </select>

                      {errors.budget && (
                        <div className="invalid-feedback">
                          {errors.budget}
                        </div>
                      )}

                    </div>

                    <div className="col-12">

                      <label
                        htmlFor="specialRequirements"
                        className="form-label"
                      >
                        Special Requirements (Optional)
                      </label>

                      <textarea
                        id="specialRequirements"
                        className="form-control"
                        rows="4"
                        value={
                          booking.specialRequirements
                        }
                        onChange={(event) =>
                          updateBooking(
                            "specialRequirements",
                            event.target.value
                          )
                        }
                      />

                    </div>

                  </div>

                  <div className="event-review-summary mb-5">

                    <h3 className="futuraPTBold mb-4">
                      Event Summary
                    </h3>

                    <div className="row g-4">

                      <div className="col-12 col-md-6">
                        <strong>
                          Event Type
                        </strong>

                        <div>
                          {booking.eventType}
                        </div>
                      </div>

                      {booking.eventType ===
                        "Tournament" && (
                        <div className="col-12 col-md-6">

                          <strong>
                            Sport
                          </strong>

                          <div>
                            {booking.tournamentSport}
                          </div>

                        </div>
                      )}

                      <div className="col-12 col-md-6">
                        <strong>
                          Event Name
                        </strong>

                        <div>
                          {booking.eventName}
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <strong>
                          Expected Guests
                        </strong>

                        <div>
                          {booking.expectedGuests}
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <strong>
                          Duration
                        </strong>

                        <div>
                          {booking.duration
                            ? `${booking.duration} hours`
                            : ""}
                        </div>
                      </div>

                      {booking.eventType ===
                        "Birthday Party" && (
                        <div className="col-12 col-md-6">

                          <strong>
                            Age Group
                          </strong>

                          <div>
                            {booking.ageGroup}
                          </div>

                        </div>
                      )}

                      <div className="col-12 col-md-6">
                        <strong>
                          Contact
                        </strong>

                        <div>
                          {booking.contactName}
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <strong>
                          Email
                        </strong>

                        <div>
                          {booking.email}
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <strong>
                          Phone
                        </strong>

                        <div>
                          {booking.phone}
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <strong>
                          Preferred Date
                        </strong>

                        <div>
                          {booking.preferredDate}
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <strong>
                          Backup Date
                        </strong>

                        <div>
                          {booking.backupDate || "Not provided"}
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <strong>
                          Preferred Time
                        </strong>

                        <div>
                          {booking.preferredTime}
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <strong>
                          Budget
                        </strong>

                        <div>
                          {booking.budget}
                        </div>
                      </div>

                      <div className="col-12">

                        <strong>
                          Services
                        </strong>

                        <div>
                          {booking.services.length > 0
                            ? booking.services.join(", ")
                            : "None selected"}
                        </div>

                      </div>

                      {booking.specialRequirements && (
                        <div className="col-12">

                          <strong>
                            Special Requirements
                          </strong>

                          <div>
                            {booking.specialRequirements}
                          </div>

                        </div>
                      )}

                    </div>

                  </div>

                  {submitError && (
                    <div
                      className="alert alert-danger mb-4"
                      role="alert"
                    >
                      {submitError}
                    </div>
                  )}

                  <div className="d-flex justify-content-between">

                    <button
                      type="button"
                      className="btn btn-secondary px-4"
                      onClick={previousStep}
                      disabled={isSubmitting}
                    >
                      Back
                    </button>

                    <button
                      type="button"
                      className="btn btn-success px-5"
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            aria-hidden="true"
                          ></span>

                          Submitting...
                        </>
                      ) : (
                        "Submit Request"
                      )}
                    </button>

                  </div>

                </div>
              )}

            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default EventBooking;